import { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let configCache = null;
export const useStay22Config = () => {
  const [config, setConfig] = useState(configCache);
  useEffect(() => {
    if (configCache) return;
    fetch(`${API}/integrations/stay22`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        configCache = d;
        setConfig(d);
      })
      .catch(() => setConfig(null));
  }, []);
  return config;
};
export const invalidateStay22Config = () => { configCache = null; };

export const buildStay22SearchUrl = ({ aid, address, checkin, checkout, adults, children, campaign }) => {
  const p = new URLSearchParams({ aid, campaign: (campaign || 'eco_accommodations').replace(/-/g, '_') });
  if (address?.trim()) p.set('address', address.trim());
  if (checkin) p.set('checkin', checkin);
  if (checkout) p.set('checkout', checkout);
  p.set('adults', String(adults ?? 2));
  p.set('children', String(children ?? 0));
  return `https://www.stay22.com/allez/searchbar?${p.toString()}`;
};

export const buildStay22EmbedUrl = ({ embedId, aid, address, lat, lng, checkin, checkout, adults, children, campaign }) => {
  const p = new URLSearchParams({ aid, campaign: (campaign || 'eco_accommodations').replace(/-/g, '_'), zoom: '12' });
  if (lat != null && lng != null) {
    p.set('lat', String(lat));
    p.set('lng', String(lng));
  } else if (address?.trim()) {
    p.set('address', address.trim());
  }
  if (checkin) p.set('checkin', checkin);
  if (checkout) p.set('checkout', checkout);
  if (adults != null) p.set('adults', String(adults));
  if (children) p.set('children', String(children));
  return `https://www.stay22.com/embed/${embedId}?${p.toString()}`;
};

export const trackStay22 = (payload) => {
  fetch(`${API}/stay22/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
};
